import React, { useState } from "react";
import { string, func, bool } from "prop-types";
import {
  Container,
  CheckboxFieldWrapper,
  CheckboxContainer,
  Icon,
  StyledCheckbox,
  HiddenCheckbox,
  CheckboxLabel,
} from "./styles";
import { Error } from "components/shared/form";
import { connect } from "formik";

const formikHandleChange = (e, formik, name) => {
  const { touched } = formik;
  e.persist();
  formik.setFieldValue(name, e.target.checked, true);
  if (!touched[name]) {
    formik.setFieldTouched(name, true, false);
  }
};

const Checkbox = ({
  label,
  name,
  disabled,
  labelInlineInd,
  reverse,
  formik,
  value = formik.values[name],
  onChange = (e) => formikHandleChange(e, formik, name),
  ...rest
}) => {
  const { errors, touched } = formik;
  const [checked, setChecked] = useState(value);
  const checkboxRef = React.createRef({});

  function handleChange(e) {
    e.persist();
    setChecked(e.target.checked);
    onChange(e);
  }

  return (
    <Container {...rest}>
      <CheckboxFieldWrapper reverse={reverse} inline={labelInlineInd}>
        <CheckboxLabel onClick={() => checkboxRef.current.click()}>
          {label}
        </CheckboxLabel>
        <label>
          <CheckboxContainer>
            <HiddenCheckbox
              ref={checkboxRef}
              disabled={disabled}
              name={name}
              onChange={handleChange}
            />
            <StyledCheckbox checked={checked}>
              <Icon viewBox="0 0 24 24">
                <polyline points="20 6 9 17 4 12" />
              </Icon>
            </StyledCheckbox>
          </CheckboxContainer>
        </label>
      </CheckboxFieldWrapper>
      {errors[name] && touched[name] && <Error>{errors[name]}</Error>}
    </Container>
  );
};

Checkbox.propTypes = {
  name: string.isRequired,
  disabled: bool,
  labelInlineInd: bool,
  value: bool,
  onChange: func,
  reverse: bool,
};

Checkbox.defaultProps = {
  label: "",
  disabled: false,
  labelInlineInd: true,
  value: false,
  reverse: false,
};

export default connect(Checkbox);
